export default {
  data() {
    return {
      commonOptionList: {
        bikeBusinessType: 1204,
        eBikeBusinessType: 1203,
        businessTypeList: [
          {
            label: '共享单车',
            value: 1204
          },
          {
            label: '电单车',
            value: 1203
          }
        ]
      }
    }
  }
}
